<template>
    <div class="container">
        <DataAtual/>
        <b-breadcrumb :items="this.$route.meta.breadcrumb"></b-breadcrumb>
        <b-card
            class="p-1 mb-3 bg-white rounded"
            header-bg-variant="transparent"
            header-class="text-center"
            footer-bg-variant="transparent">
            <template v-slot:header v-if="labelLinkEdicao">
                <b-link
                    @click="abrirDocumentoJornal()"
                    class="linkEdicao">
                    <i class="fa fa-newspaper-o pr-1"></i> {{ labelLinkEdicao }}
                </b-link>
            </template>

            <h6 v-if="tituloAto" class="mb-0 text-muted text-center font-weight-bold">{{tituloAto}}</h6>
            <h6 v-if="tituloEdicao" class="titulo mb-0 text-muted text-center">{{tituloEdicao}}</h6>
            <h6 v-if="tituloOrgao" class="mb-0 titulo text-muted text-center">{{tituloOrgao}}</h6>

            <div v-if="conteudoHTMLAto"
                 v-html="conteudoHTMLAto"
                 class="mt-2">
            </div>
            <p v-if="!conteudoHTMLAto && !carregando" class="mt-4 text-muted text-center ">Documento indisponível</p>

            <div class="mt-4 text-center" v-if="anexosAto && anexosAto.length > 0">
                <b-button
                    size="sm"
                    variant="outline-secondary"
                    @click="visualizarAnexos = !visualizarAnexos"
                    :pressed="visualizarAnexos"
                >
                    <i v-bind:class="[visualizarAnexos ? 'fa fa-arrow-down' : 'fa fa-arrow-right']"></i> Visualizar Anexos do Ato
                </b-button> <!-- Using value -->

                <b-collapse v-model="visualizarAnexos">
                    <b-card class="my-3">
                        <ul class="list-unstyled">
                            <li v-for="anexoAto in anexosAto" :key="anexoAto.id">
                                <b-link
                                    @click="$helper.exibirAnexo($env.VUE_APP_URL_API, anexoAto)"
                                    target="_blank"
                                    class="anexo">
                                    <i class="fa fa-file-o pr-1 icon-doc" ></i> {{anexoAto.documento_anexo_ato.nome_original}}
                                </b-link>
                            </li>
                        </ul>
                    </b-card>
                </b-collapse>
            </div>

            <template v-slot:footer >
                <b-row >
                    <b-col class="text-left">
                        <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click.prevent="$router.push({ path: $route.meta.breadcrumb[$route.meta.breadcrumb.length - 2].to})"
                        >
                            <i class="fa fa-arrow-left pr-1" ></i> Voltar
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-card>
    </div>
</template>
<script>


import DataAtual from '../../components/DataAtual';
import router from '../../routes';
import Edicao from '../../models/Edicao'
import Ato from '../../models/Ato'

export default {
    name: 'visualizacao',

    components: {
        DataAtual
    },

    data(){
        return {
            labelLinkEdicao: '',
            tituloAto: '',
            tituloEdicao:'',
            tituloOrgao:'',
            conteudoHTMLAto: null,
            anexosAto: [],
            visualizarAnexos:false,
            ato: new Ato(),
            carregando: true,
        }
    },

    methods: {
        loaded() {
            this.carregando = router.app.carregando = false;
        },

        obterAto(id){
            return this.$api.ato.obterPublicado(id)
                .then(response => {
                    return response.data && response.data.success ? new Ato(response.data.data) : null;
                });
        },

        setConteudoHTMLAto(nome_minio, prefix){
             this.$api.ato.buscarDocumentoConteudoHTML(nome_minio, prefix)
                .then( response => {
                    if(response.data){
                        this.conteudoHTMLAto = response.data;
                    }
                })
                .finally(() => {
                    this.carregando = router.app.carregando = false;
                });
        },

        setDadosEdicao(idEdicao){
            this.$api.edicao.obterPublicado(idEdicao)
                .then(response => {
                    if(response.data && response.data.success){
                        this.ato.edicao = new Edicao(response.data.data);
                        this.labelLinkEdicao = this.ato.edicao && this.ato.edicao.documento_jornal.nome_minio ? "Acesse a Edição" : null;
                        this.tituloEdicao = "Edição: "+ this.ato.edicao.numero_edicao +" | "+ this.$helper.getTipoEdicao(this.ato.edicao.tipo_edicao)  +" | Ano "+ this.ato.edicao.ano_romanos_edicao + " | Publicada em: "+ this.$helper.formatDataBrasil(this.ato.edicao.dt_publicacao);
                    }
                })
        },

        setDadosAnexos(idAto){
            this.$api.anexoAto.listarPublicados(idAto)
                .then( response => {
                if(response.data && response.data.success){
                    this.anexosAto = response.data.data;
                }
            });
        },

        abrirDocumentoJornal(){
            let url = `${this.$env.VUE_APP_URL_API}/api/v1/documentos/${this.ato.edicao.documento_jornal.nome_minio}`;
            if(this.ato.edicao.documento_jornal.size > this.$constantes.documentos.TAMANHO_LIMITE_PARA_VISUALIZACAO){
                url += '/download';
                if(this.ato.edicao.documento_jornal.prefix){
                    url += `?prefix=${this.ato.edicao.documento_jornal.prefix}`;
                }
                window.location.assign(url);
            }else{
                if(this.ato.edicao.documento_jornal.prefix){
                    url += `?prefix=${this.ato.edicao.documento_jornal.prefix}`;
                }
                window.open(url);
            }
        }
    },

    async mounted(){
        this.carregando = router.app.carregando = true;

        this.ato = await this.obterAto(this.$route.params.id);
        if(this.ato){
            this.tituloAto = this.ato.categoria.nome_categoria +": "+ this.ato.titulo_ato;
            this.tituloOrgao = this.ato.orgao.sigla_orgao + " - " + this.ato.orgao.nome_orgao;

            this.setDadosEdicao(this.ato.edicao_id);
            await this.setDadosAnexos(this.ato.id);

            if(this.ato.documento_ato.nome_minio){
                this.setConteudoHTMLAto(this.ato.documento_ato.nome_minio, this.ato.documento_ato.prefix);
            }else{
                this.carregando = router.app.carregando = false;
            }
        }else{
            this.carregando = router.app.carregando = false;
        }
    }
}
</script>
<style scoped>
    .linkEdicao {
        font-size: 90%;
    }

    .anexo{
        font-size: 80%;
    }

   .breadcrumb{
        font-size: 0.9em;
    }

    .icon-doc{
        color: #6c757d;;
    }

</style>